import { Schema, isSchema as isYupSchema } from 'yup';

export function isSchema<T = unknown>(value: unknown): value is Schema<T> {
  return value !== undefined && isYupSchema(value);
}
